import {ITheme} from "../interfaces/themes/ITheme";
// palette: WTIPaletteOptions,
export const typography = ({palette, breakpoints}: ITheme) => {
	return {
		fonts: {
			monospace: 'Monospace',
		},
		fontFamily: [
			"Monospace",
		].join(","),
		h1: {
			color: palette.text.primary,
			letterSpacing: -1,
			alignSelf: 'center',
			[breakpoints.down('md')]: {
				fontSize: 44,
			},
			[breakpoints.up('md')]: {
				fontSize: 64,
			},
		},
		h2: {
			// color: palette.text.primary,
			color: palette.text.quaternary,
			letterSpacing: -1,
			[breakpoints.down('md')]: {
				fontSize: 30,
			},
			[breakpoints.up('md')]: {
				fontSize: 44,
			},
			zIndex: 1,
			fontStyle: "italic",
			// alignSelf: 'center',
		},
		h3: {
			letterSpacing: -1,
		},
		h4: {
			color: palette.text.primary,
			[breakpoints.down('md')]: {
				fontSize: 28,
			},
			[breakpoints.up('md')]: {
				fontSize: 32,
			},
			letterSpacing: -1,
			lineHeight: 1.2,
		},
		h5: {
			color: palette.text.primary,
			[breakpoints.down('md')]: {
				fontSize: 24,
			},
			[breakpoints.up('md')]: {
				fontSize: 28,
			},
			letterSpacing: -1,
			lineHeight: 1.2,
		},
		h6: {
			color: palette.text.primary,
			[breakpoints.down('md')]: {
				fontSize: 22,
			},
			[breakpoints.up('md')]: {
				fontSize: 26,
			},
			letterSpacing: -1,
			lineHeight: 1.2,
		},
		body1: {
			// color: palette.text.quaternary,
			letterSpacing: -1,
			[breakpoints.down('md')]: {
				fontSize: 18,
			},
			[breakpoints.up('md')]: {
				fontSize: 19,
				// color: '#444',
			},
			lineHeight: 1.2,
		},
		body2: {
			letterSpacing: -1,
		},
		subtitle1: {
			color: palette.text.primary,
			letterSpacing: -1,
			fontSize: 20,
		},
		subtitle2: {
		},
	}
};
